exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dv-water-pond-level{position:relative}.dv-water-pond-level svg{position:absolute;width:100%;height:100%;top:0;left:0}.dv-water-pond-level text{font-size:25px;font-weight:700;text-anchor:middle;dominant-baseline:middle}.dv-water-pond-level ellipse,.dv-water-pond-level rect{fill:none;stroke-width:3}.dv-water-pond-level canvas{margin-top:8px;margin-left:8px;width:calc(100% - 16px);height:calc(100% - 16px);box-sizing:border-box}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/@jiaminghi/data-view/lib/components/waterLevelPond/src/main.css
// module id = 1104
// module chunks = 45